import React from 'react'

import { Flag } from '@UI/crypto_exchange/desktop/components/controls/InputSelectNew/Flag/Flag'

interface ITransferWalletValue {
  selected: any
  name: any
  containerRef: any
  setShowList: any
  showList: boolean
  search: string
  setSearch: any
  className?: string
  isTransferWallet?: boolean
  isRegistration?: boolean
  countryId?: string | null
  readOnly?: boolean
}

export default function InputTransferWallet({
  selected,
  name,
  containerRef,
  setShowList,
  showList,
  search,
  setSearch,
  className = '',
  isTransferWallet = false,
  isRegistration = false,
  countryId = '',
  readOnly = false,
}: ITransferWalletValue) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!readOnly) {
      setSearch(e.target.value)
    }
  }
  const getInputValue = () => {
    if (readOnly) {
      return selected?.label ?? ''
    } else {
      return showList ? search : selected?.label ?? ''
    }
  }

  return (
    <>
      {isTransferWallet ? (
        <input
          className={className}
          name={name}
          ref={containerRef}
          defaultValue={selected?.label}
          onClick={() => (isTransferWallet ? setShowList(!showList) : null)}
          readOnly={readOnly}
        />
      ) : (
        <>
          {isRegistration ? <Flag country_id={countryId} size={28} /> : null}
          <input
            className={className}
            name={name}
            ref={containerRef}
            value={getInputValue()}
            onClick={() => setShowList !== null ? setShowList(!showList) : null}
            onFocus={() => setShowList !== null ? setShowList(true) : null}
            onChange={handleChange}
            readOnly={readOnly}
            placeholder={isRegistration && !selected ? 'Select country' : undefined}
          />
        </>
      )}
    </>
  )
}
